import { useContext } from "react";
import { SearchVehicleByParamsDataContext } from "../SearchVehicleByParamsDataProvider";
import { LoadingData } from "../types";
import Preloader from "@/ui/Loader/Preloader";

/**
 * Обработчик загрузки
 * @param {React.ReactNode} children - Дочерние компоненты
 * @returns {React.ReactNode}
 */
export const LoadindHandler = ({ children }: { children: React.ReactNode }) => {
    const { isLoading, error } = useContext(SearchVehicleByParamsDataContext) as LoadingData;

    if (error) {
        console.error(error);
    }

    return isLoading ? <Preloader/> : children;
};